import React, { useState } from 'react';
import { formatDateWithMonthName } from './formatters';

import { ReactComponent as ArrowDownIcon } from '../../../Shared/svgs/arrow-triangle-down-magenta.svg';
import { ReactComponent as ArrowRightIcon } from '../../../Shared/svgs/arrow-triangle-right-magenta.svg';
import { ReactComponent as ApartmentsHouseIcon } from '../../../Shared/svgs/apartments-house-magenta.svg';

export default function SitesWithStreams({ sites = [] }) {
    const [isOpen, setIsOpen] = useState(false);              // whole block
    const [expandedSites, setExpandedSites] = useState({});   // per site

    const toggleDropdown = () => setIsOpen((prev) => !prev);
    const toggleSite = (key) =>
        setExpandedSites((prev) => ({ ...prev, [key]: !prev[key] }));

    return (
        <div className="generic-details__block sites-list">
            <div className="sites-header" onClick={toggleDropdown}>
                <h3>Sites</h3>
                {isOpen ? <ArrowDownIcon className="arrow-icon" /> : <ArrowRightIcon className="arrow-icon" />}
            </div>

            {isOpen && (
                <ul className="generic-site-list">
                    {sites.map((site, index) => {
                        const { address, wasteStreams = [] } = site || {};
                        const siteKey = site?.id ?? site?.siteId ?? index;
                        const isSiteOpen = !!expandedSites[siteKey];

                        return (
                            <li key={siteKey} className="site-item site-item--with-streams">
                                <button
                                    type="button"
                                    className="site-item__toggle"
                                    onClick={() => toggleSite(siteKey)}
                                    aria-expanded={isSiteOpen}
                                >
                                    <div className="site-item__header">
                                        <ApartmentsHouseIcon className="apartments-icon" />
                                        <span>{address || '-'}</span>
                                    </div>
                                    {isSiteOpen ? (
                                        <ArrowDownIcon className="arrow-icon" />
                                    ) : (
                                        <ArrowRightIcon className="arrow-icon" />
                                    )}
                                </button>

                                {isSiteOpen && wasteStreams.length > 0 && (
                                    <div className="waste-streams">
                                        <div className="waste-streams__row waste-streams__row--head">
                                            <div className="waste-streams__cell">Waste Stream</div>
                                            <div className="waste-streams__cell">Collection Frequency</div>
                                            <div className="waste-streams__cell">Next Collection</div>
                                            <div className="waste-streams__cell">Maximum Weight</div>
                                        </div>

                                        {wasteStreams.map((stream, streamIndex) => {
                                            const streamName = stream?.serviceTypeName === null ? '-' :
                                                stream?.serviceTypeName + ' ' + stream?.assetTypeDescription;
                                            return (
                                                <div
                                                    key={stream?.assetId ?? streamIndex}
                                                    className="waste-streams__row"
                                                >
                                                    <div className="waste-streams__cell">
                                                        {streamName}
                                                    </div>
                                                    <div className="waste-streams__cell">
                                                        {stream?.collectionFrequency || '-'}
                                                    </div>
                                                    <div className="waste-streams__cell">
                                                        {formatDateWithMonthName(stream?.nextCollectionDate)}
                                                    </div>
                                                    <div className="waste-streams__cell">
                                                        {stream?.maximumWeight != null ? `${stream.maximumWeight}kg` : '-'}
                                                    </div>
                                                </div>
                                            );
                                        }
                                    )}
                                    </div>
                                )}
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
